import {CREATE_LOG_SUCCESS, FETCH_LOG_SUCCESS, GET_LOG_SUCCESS, SAVE_LOG_QUERY} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_LOG_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_LOG_SUCCESS: {
      const query = {...state.query};
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_LOG_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_LOG_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }


    default:
      return state;
  }
}
